import {
  Accessibility, ArrowBigUp, ArrowLeft, ArrowRight, Book, BookMarked, Bookmark, BookOpen, Calendar, Check, ChevronDown, ChevronLeft,
  ChevronRight, ChevronUp, CircleHelp, Clock, CornerDownLeft, Delete, Download, Eye, FileText, Gift, Globe, Hash, Headphones, Heart,
  House, Image, Info, Landmark, Languages, LayoutGrid, Library, List, ListFilter, Mail, MapPin, Menu, Minus, PenLine, Phone, Play,
  Pause, Plus, QrCode, Search, Settings, Share2, ShoppingBag, ShoppingCart, Sparkles, Star, Tag, Ticket, User, Users, Video, Volume2, X,
} from "lucide-react";

export const KIOSK_ICONS = {
  ArrowLeft, ArrowRight, ChevronLeft, ChevronRight, ChevronUp, ChevronDown, House, Menu, X, Check, Plus, Minus,
  CircleHelp, Info, Languages, Globe, Search, ListFilter, LayoutGrid, List, Settings, Accessibility,
  BookOpen, Book, BookMarked, Bookmark, Library, FileText, PenLine, User, Users, Landmark,
  ShoppingCart, ShoppingBag, Tag, Ticket, Gift, Star, Heart, Sparkles, Eye, Share2, Download,
  Calendar, Clock, MapPin, Phone, Mail, Play, Pause, Volume2, Headphones, Image, Video, QrCode, Hash,
  ArrowBigUp, Delete, CornerDownLeft,
};

export const KIOSK_ICON_NAMES = Object.keys(KIOSK_ICONS);

export function KioskIcon({ name, size = 16, color = "currentColor", strokeWidth = 2, style }) {
  if (!name) return null;
  const Cmp = KIOSK_ICONS[name];
  if (Cmp) return <Cmp size={size} color={color} strokeWidth={strokeWidth} style={{ flexShrink: 0, display: "block", ...style }} />;
  return <span style={{ fontSize: size, lineHeight: 1, flexShrink: 0, color, ...style }}>{name}</span>;
}
